import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

// Heroicons outline "credit-card" (double top stripe + two number-line strokes) - the Delete
// card confirm modal's big icon (Figma). Not Icons/CreditCard.tsx (a plainer rect+single-line
// glyph used for TeamMemberCardArt's mini badge) - this one matches the more detailed asset
// Figma gave specifically for this confirmation, and stays currentColor rather than the pasted
// asset's hardcoded stroke="white" so it still reads white sitting inside ConfirmActionModal's
// danger-toned icon circle via the circle's own text color.
const CreditCardOutline = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ size, variant, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path d="M4.5 16.5H43.5M4.5 18H43.5M10.5 28.5H22.5M10.5 33H16.5M9 39H39C41.4853 39 43.5 36.9853 43.5 34.5V13.5C43.5 11.0147 41.4853 9 39 9H9C6.51472 9 4.5 11.0147 4.5 13.5V34.5C4.5 36.9853 6.51472 39 9 39Z" />
  </svg>
);

export default CreditCardOutline;
